import styles from './StateView.module.css';

export const StateView = ({
    image,
    headerMessage,
    descriptionMessage
}: {
    image: React.ReactNode;
    headerMessage: React.ReactNode;
    descriptionMessage: React.ReactNode;
}) => (
    <div className={styles.StateView}>
        <div className={styles.inner}>
            <div className={styles.image}>{image}</div>
            <div className={styles.header}>{headerMessage}</div>
            <div className={styles.description}>{descriptionMessage}</div>
        </div>
    </div>
);
